import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AlignItemsRight = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          d="M11.5 6.5V3h-8v3.5h8Zm1-3.5a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3ZM14 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 14 1Zm-2.5 8.5V13h-4V9.5h4Zm0-1a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V9.5a1 1 0 0 1 1-1h4Z"
          clipRule="evenodd"
        />
      </svg>
    )
  },
)

export default AlignItemsRight
